import { useState, useCallback } from 'react'

interface IUseFetchDataState {
  errors?: string | undefined
  isLoading: boolean
  fetchData: <T>(promise: Promise<T>) => Promise<T>
}

export const useFetchData = (): IUseFetchDataState => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<string | undefined>(undefined)

  const fetchData = useCallback(async <T>(promise: Promise<T>): Promise<T> => {
    setLoading(true)
    setErrors(undefined)

    try {
      const res = await promise
      setLoading(false)
      return res
    } catch (e) {
      setLoading(false)
      if (e !== 'Error: API route not found.') setErrors(e)
      return e
    }
  }, [])

  return {
    isLoading,
    errors,
    fetchData,
  }
}
